import { render, staticRenderFns } from "./darkFooter.vue?vue&type=template&id=24ba45ee&"
import script from "./darkFooter.vue?vue&type=script&lang=js&"
export * from "./darkFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports